import { __rest } from "tslib";
import * as React from 'react';
import { Badge as AntdBadge } from 'antd';
import variables from '@web-common/styles/export.module.scss';
import classNames from 'classnames';
import './style.scss';
export const Badge = props => {
    const { dot, intro, count, dotSize, color, children, className } = props, restProps = __rest(props, ["dot", "intro", "count", "dotSize", "color", "children", "className"]);
    const classes = React.useMemo(() => classNames(`${variables.classPrefix}-badge`, className, { [`${variables.classPrefix}-badge-single-number`]: typeof count === 'number' && count >= 0 && count <= 9 }, { [`${variables.classPrefix}-badge-not-number`]: intro }, { [`${variables.classPrefix}-badge-dot-sm`]: dotSize === 'small' }), [className, intro, dotSize, count]);
    const currentCount = React.useMemo(() => {
        if (intro) {
            return (React.createElement("span", { className: `${variables.classPrefix}-badge-intro` },
                React.createElement("span", { className: "text" }, intro)));
        }
        return count;
    }, [intro, count]);
    const currentColor = React.useMemo(() => {
        if (color) {
            return color;
        }
        if (dot && !children) {
            return variables.error6;
        }
        return undefined;
    }, [color, children]);
    return (React.createElement(AntdBadge, Object.assign({ dot: dot, color: currentColor, className: classes, count: currentCount }, restProps), children));
};
Badge.defaultProps = {
    intro: '',
    dotSize: 'default',
    dot: false,
    overflowCount: 99,
    showZero: false,
};
export default Badge;
